import { render, staticRenderFns } from "./Utilization.vue?vue&type=template&id=636560da&scoped=true"
import script from "./Utilization.vue?vue&type=script&lang=js"
export * from "./Utilization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636560da",
  null
  
)

export default component.exports